/** Parse "YYYY-MM-DD" to { year, month, day } (month 1–12) */
export function parseYYYYMMDD(
  str: string
): { year: number; month: number; day: number } | null {
  const trimmed = (str ?? '').toString().trim();
  const match = trimmed.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (
    !Number.isFinite(year) ||
    !Number.isFinite(month) ||
    !Number.isFinite(day) ||
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > getDaysInMonth(year, month)
  ) {
    return null;
  }
  return { year, month, day };
}

/** Convert year, month (1–12), day to "YYYY-MM-DD" */
export function toYYYYMMDD(year: number, month: number, day: number): string {
  const y = String(year).padStart(4, '0');
  const m = String(month).padStart(2, '0');
  const d = String(day).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Days in month (1–12). Handles leap years. */
export function getDaysInMonth(year: number, month: number): number {
  if (month < 1 || month > 12) return 31;
  const nextMonth = new Date(year, month, 0);
  return nextMonth.getDate();
}

/** Default date for future scheduling: tomorrow */
export function getDefaultFutureDate(): { year: number; month: number; day: number } {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return {
    year: tomorrow.getFullYear(),
    month: tomorrow.getMonth() + 1,
    day: tomorrow.getDate()
  };
}
